<template>
  <div class="m-paginate">
    <div v-if="useUrl">
      <v-button
        type="outline-1"
        class="m-paginate__button"
        :disabled="loading || !showPrevious"
        :transition="true"
        :action="clickPrev"
        :to="prevUrl"
        data-test="page-previous">Previous</v-button>
      <div class="m-paginate__indicator">
        {{ currentPageInteger }} of {{ lastPageInteger }}
      </div>
      <v-button
        type="outline-1"
        class="m-paginate__button"
        :disabled="loading || !showNext"
        :transition="true"
        :action="clickNext"
        :to="nextUrl"
        data-test="page-next">Next</v-button>
    </div>
    <div v-else>
      <v-button
        type="outline-1"
        class="m-paginate__button"
        :disabled="loading || !showPrevious"
        :transition="true"
        :action="clickPrev"
        href="#"
        data-test="page-previous">Previous</v-button>
      <div class="m-paginate__indicator">
        {{ currentPageInteger }} of {{ lastPageInteger }}
      </div>
      <v-button
        type="outline-1"
        class="m-paginate__button"
        :disabled="loading || !showNext"
        :transition="true"
        :action="clickNext"
        href="#"
        data-test="page-next">Next</v-button>
    </div>
  </div>
</template>

<script>
import { VButton } from '../atoms';

export default {
  name: 'v-paginate',
  components: {
    VButton,
  },
  props: {
    last: {
      type: [Number],
      required: true,
    },
    current: {
      type: [Number],
      required: true,
    },
    storeAction: {
      type: [String],
      required: true,
    },
    value: [Object, String],
    useUrl: {
      type: [Boolean],
      required: false,
    },
    loading: {
      type: [Boolean],
      required: false,
      default: false,
    },
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    currentPageInteger() {
      return Number.parseInt(this.current, 10);
    },
    lastPageInteger() {
      if (!this.last >= 1) {
        return 'unknown';
      }

      return Number.parseInt(this.last, 10);
    },
    showPrevious() {
      if (this.currentPageInteger <= 1) {
        return false;
      }

      return true;
    },
    showNext() {
      if (this.currentPageInteger >= this.lastPageInteger) {
        return false;
      }

      return true;
    },
    nextUrl() {
      const pageNum = this.current - 1;
      if (pageNum >= this.last) return this.last.toString();

      return (this.current + 1).toString();
    },
    prevUrl() {
      const pageNum = this.current - 1;
      if (pageNum < 1) return '1';
      return pageNum.toString();
    },
  },
  methods: {
    clickNext() {
      const page = this.currentPageInteger + 1;
      this.$store.dispatch(this.storeAction, { page });
      this.$bus.$emit('scrollTo', { amount: 0 });
    },
    clickPrev() {
      const page = this.currentPageInteger - 1;
      this.$store.dispatch(this.storeAction, { page });
      this.$bus.$emit('scrollTo', { amount: 0 });
    },
  },
  watch: {
    current: {
      handler() {
        if (!this.loading && this.currentPageInteger > this.lastPageInteger) {
          if (this.useUrl === true) {
            this.$router.replace(this.last.toString());
            this.$bus.$emit('renderGlobalMessage', ({ message: 'Page beyond limit, showing last page instead.', icon: 'exclamation-triangle', type: 'warning' }));
          }

          this.$store.dispatch(this.storeAction, { page: this.last });
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/component-utils';

  $parent: '.m-paginate';

  #{$parent} {
    margin-top: $spacing-base;
    text-align: center;
    //elements
    &__button {
      float: none !important;
      display: inline-block !important;
    }
    &__indicator {
      display: inline-block !important;
      padding: 0 $spacing-base;
    }
  }
</style>
